<template>

<div>
	
	<div v-if="this.$route.name === 'search_results'">
		<h5 class="gold">
			<i class="fas fa-search fa-1x"></i> Search Results for "<small v-text="search_term"></small>"
		</h5>
		
		<div class="row mb-3">
			<div class="col-sm-6">
				<b-form-input
					id="search_term"
					v-model="search_term"
					type="text"
					required
					placeholder="Search"
					maxlength="150"
					class="p-1 m-1"
				></b-form-input>
			</div>
			<div class="col-sm-3">
				<b-button class="m-1 gold" type="button" @click="getSearchResults()">
					<i class="fas fa-search"></i> Search
				</b-button>
			</div>
		</div>
	</div>
	
	<div v-else>
		<h5 class="row" v-if="page_loaded == 1">
			<div class="col-10 col-sm-9">
				<router-link to="/" class="mr-2 gold"><small>Latest</small></router-link>
				<i :class="active_category.icon" class="fa-1x"></i> <span v-text="active_category.title"></span>
			</div>
			<div class="col-1 col-sm-3 text-right gold add_post_btn">
				<router-link :to="'/post_add/' + this.$store.state.category_slug" class="btn btn-sm btn-secondary gold">
					<i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Start New Thread</span>
				</router-link>
			</div>
		</h5>
	</div>
	
	
	
	<div class="table-responsive-md">
	<b-table striped hover small :items="posts" :fields="fields" class="" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
	
		<template v-slot:table-busy>
			<div class="text-center my-2 p-2 gold">
				<b-spinner class="align-middle"></b-spinner>
				<br />
				<strong>Loading...</strong>
			</div>
		</template>
		
		<template v-slot:cell(icon)="data">
			<div class="text-center pointer gold" @click="loadCatPosts(data.item.category)">
				<i :class="data.item.categories[data.item.category].icon" class="fa-2x"></i>
			</div>
		</template>
		
		<template v-slot:cell(title)="data">
			<b v-text="data.item.title" @click="loadPostID(data.item.id)" class="pointer"></b><br />
			<span v-text="data.item.description" @click="loadPostID(data.item.id)" class="pointer"></span>
		</template>
		
		<template v-slot:cell(user_name)="data">
			<span v-text="data.item.user_name" class="btn-link pointer gold" @click="userProfile(data.item.user_id)"></span>
		</template>
		
		<template v-slot:cell(id)="data">
			<small class="hide" v-text="data.item.id"></small>
			<small v-text="data.item.access.date"></small><br />
			<small v-text="data.item.access.time"></small>
		</template>
		
		<template v-slot:cell(updated)="data">
			<small class="hide" v-text="data.item.id"></small>
			<small v-text="data.item.updated.date"></small><br />
			<small v-text="data.item.updated.time"></small>
		</template>

	
	</b-table>
	</div>
	
	
	<div v-if="posts.length == 0">
		<p>No Results</p>
		<div v-if="page_loaded == 0">
			<div class="text-center my-2 p-2 gold">
				<b-spinner class="align-middle"></b-spinner>
				<br />
				<strong>Loading...</strong>
			</div>
		</div>
	</div>
	
	
</div>

</template>

<script>
import axios from "axios";

export default {
	name: "ForumList",
	components:{ 
	},
	props: {
		category: {
			type: String,
			default: 'latest',
		}
	},
	data() {
		return {
			active_category: {},
			fields: [
				{ key: 'icon', label: ''},
				{ key: 'title', label: '', class: 'td_min_width', },
				{ key: 'user_name', label: 'Author', sortable: true },
				{ key: 'replies_count', label: 'Replies', sortable: true },
				{ key: 'views', label: 'Views', sortable: true },
				{ key: 'id', label: 'Posted', sortable: true },
				{ key: 'updated', label: 'Activity', sortable: true },
				
			],
			page_loaded: 0,
			posts: [],
			search_term: this.$store.state.search_term,
			session_id: this.$store.state.session_id,
			sortBy: 'id',
			sortDesc: true,
			temp : null,
		}
	},
	computed:{
	},
	methods:{
		
		categorySetSelected(category_slug){
			console.log('categorySetSelected:'+category_slug);
			this.$store.commit("categoryActiveSet", category_slug);
			this.active_category = this.$store.getters.categoryActiveGet;
			
			if(this.active_category === null){
				if(this.$route.name === 'search_results'){
					document.title = this.$route.meta.title + ' - iAMconnected Forum';
					this.active_category = {
						icon : 'fas fa-list',
						title: this.$route.meta.title,
						slug: this.$route.name,
					};
				}
				else
				{
					document.title = 'Latest Chatter - iAMconnected Forum';
					this.active_category = {
						icon : 'far fa-comments',
						title: 'Forum Dashboard',
						slug: 'latest',
					};
				}
				
			}
			else
			{
				document.title = this.active_category.title + ' - iAMconnected Forum';
			}
			
		},
		
		forumGet(cat_slug){
			let _this = this;
			
			this.page_loaded = 0;
			_this.posts = [];

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('type', 'list');
			if(cat_slug !== null && cat_slug !== 'latest'){
				params.append('category', cat_slug);
			}
			axios({
				url: _this.$store.state.api_url + "forum",
				params: params,

			}).then(function (response) {
				
				_this.posts = [];
				
				if(response.data.status == 1 && response.data.posts !== null){
					const post_entries = Object.entries(response.data.posts);
					for (const [k, obj] of post_entries) {
						_this.temp = k;
						_this.posts.push(obj);
					}
				}
				
				_this.page_loaded = 1;
				
			}).catch(function (error) {
				console.log(error);
			});
			
			
		},
		
		getSearchResults(){
			let _this = this;
			
			_this.posts = [];

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('term', this.search_term);

			axios({
				url: _this.$store.state.api_url + "forum/search",
				params: params,

			}).then(function (response) {
				
				_this.posts = [];
				
				if(typeof response.data.results !== 'undefined'){
					_this.posts = Object.values(response.data.results);
				}
				
				_this.page_loaded = 1;
				
			}).catch(function (error) {
				console.log(error);
			});
			
			
		},
		
		loadCatPosts(cat){
			if(typeof this.active_category.slug !== 'undefined' && cat !== this.active_category.slug){
				this.posts = [];
				this.$router.push('/categories/' + cat);
			}
		},
		
		loadPostID(id){
			this.$router.push('/post/' + id);
		},
		
		postAdd(){
			this.$router.push('/post_add');
		},
		
		userProfile(user_id){
			console.log('userProfile:' + user_id);
		},
		
	},
	mounted() {
		this.categorySetSelected(this.category);
		
		if(this.category === 'search_results'){
			this.getSearchResults();
		}
		else
		{
			this.forumGet(this.category);
		}
	},
	watch: {
		'$store.state.category_slug': function(val){
			if(typeof val !== 'undefined'){
				console.log('store.state.category_slug - change:' + val);
				this.categorySetSelected(val);
				this.forumGet(val);
			}
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
    line-height: 1.2rem;
    font-size: 0.8rem;
    color: #3e3e3e;
}
.hide {
	display:none;
}
</style>
